import { Observable } from 'rxjs';
import { ItemBaseModel } from '../../../item-base.model';
import { InputItemBaseModel } from '../input-item-base.model';
import { FileUploadModel } from './file-upload.model';

/**
 * We're allowing map mime-type and allowed file endings:
 *
 * {
 *   "mimeType": "image/jpeg",
 *   "fileEndings": ["jpg", "jpeg"]
 * }
 */
export interface FileInputAllowedTypeModel {
  mimeType: string;
  extensions: string[];
}

export interface FileInputAllowedModel {
  maxSize: number;
  types: FileInputAllowedTypeModel[];
}

export interface FileValidationErrorModel {
  data: File;
  maxSize?: number;
  types?: FileInputAllowedTypeModel[];
  message?: string;
}

export interface FileValidationErrorCollection {
  file: FileValidationErrorModel[];
}

export interface FileInputValueModel {
  file: File;
  fileIdentifier?: string;
}

/**
 * Handles file upload and returns `FileUploadResultModel`
 *
 * Throws `FileUploadErrorModel`
 */
export type FileUploadHandler = (file: File) => Observable<FileUploadModel>;

export interface FileInputModel extends InputItemBaseModel {
  type: 'file';
  allowed?: FileInputAllowedModel;
  uploadCallback?: FileUploadHandler;
}

export const isFileInput = (item: ItemBaseModel): item is FileInputModel => {
  return item.type === 'file';
};
